const dynamicReducer = (state = null, action) => {
    switch (action.type) {
      case "SET_VALUE":
        return action.state;
      default:
        return state;
    }
  };
  export default dynamicReducer;